import { Applicant, GroupedApplicant } from 'store/dashboard/types'

export function groupApplicantsByApplicantCleaned(applicants: Applicant[], subgroups: string[]): GroupedApplicant[] {
  // groupedApplicants as map to group by `applicant_cleaned`
  const groupedApplicants: { [key: string]: Applicant[] } = {}

  // Go through the list of applicants and group by `applicant_cleaned`
  applicants.forEach(applicant => {
    if (subgroups.includes(applicant.subgroup)) {
      const key = 'clean_' + applicant.applicant_cleaned.toString()
      if (!groupedApplicants[key]) {
        groupedApplicants[key] = []
      }
      groupedApplicants[key].push(applicant)
    }
  })

  // Transform the objet agrupado in an array of `GroupedApplicant`
  return Object.keys(groupedApplicants).map(key => {
    const base = groupedApplicants[key][0]
    return {
      applicant_cleaned: key,
      applicant_original_name: base.applicant_original_name,
      research: base.research,
      whales_patent_in_percent: base.whales_patent_in_percent,
      whales_patents_in_categories: base.whales_patents_in_categories,
      whales_categories_count: base.whales_categories_count,
      whales_patent_count: base.whales_patent_count,
      whales_patent_in_percent_category: base.whales_patent_in_percent_category,
      whales_patent_out_category: base.whales_patent_out_category,
      applicantBySubgroup: groupedApplicants[key],
    }
  })
}
